const questions = [
  {
    id: 1,
    question: "___ finished the report, she sent it to her manager.",
    options: ["After she", "Having", "Because"],
    answer: "Having",
    concept: "reduced_participle_clause",
    skill: "clause_reduction",
    explanation: "‘Having + past participle’ is used to show that one action was completed before another."
  },
  {
    id: 2,
    question: "The book ___ on the table belongs to me.",
    options: ["is lying", "lying", "lies"],
    answer: "lying",
    concept: "reduced_relative_clause",
    skill: "participle_modifier",
    explanation: "A reduced relative clause uses the -ing form to describe a noun more concisely."
  },
  {
    id: 3,
    question: "___ he said shocked the audience.",
    options: ["That", "What", "Which"],
    answer: "What",
    concept: "noun_clause_subject",
    skill: "clause_as_subject",
    explanation: "'What' is used to introduce a noun clause that acts as the subject of the sentence."
  },
  {
    id: 4,
    question: "Despite ___ very tired, he continued working.",
    options: ["be", "being", "was"],
    answer: "being",
    concept: "preposition_followed_by_gerund",
    skill: "gerund_usage",
    explanation: "After prepositions like 'despite', we use the gerund (-ing) form."
  },
  {
    id: 5,
    question: "This is the reason ___ she resigned.",
    options: ["which", "what", "why"],
    answer: "why",
    concept: "relative_reason_clause",
    skill: "relative_words",
    explanation: "'Why' is used after words like 'reason' to explain cause."
  }
];

export default questions;


